import React, { useState, useEffect } from "react";
import { Flex, Table, message } from "antd";
import { useNavigate } from "react-router-dom";
import { GetLocations, DeleteLocation } from "../../api's/settings.js";
import {
  CustomParagraph,
  CustomTitle,
  AddItemButton,
} from "../../components/index.js";
import { useToken } from "../../common/helper/index.js";
import { useSpin } from "../../components/SpinContext.js";
import deleteIcon from "../../assets/images/delete.svg";
import { Switch, Tooltip } from "antd";
import editIcon from "../../assets/images/edit-icon.svg";
import mailIcon from "../../assets/images/mail.svg";
import phoneIcon from "../../assets/images/phone.svg";
import { useDispatch, useSelector } from "react-redux";
import CommonDrawer from "../../components/CommonDrawer.jsx";
import {
  fetchAllLocations,
  selectLocationState,
} from "../../reudx-toolkit/slice/LocationSlice.js";
import CustomDeleteModal from "../Modals/CustomDeleteModal.jsx";
import LocationForm from "./LocationForm.jsx";
import TeamsTag from "../../components/TeamsTag.jsx";
import { getTeamsDDL } from "../../common/utils/dropDown.js";
import TeamBadge from "../../components/TeamBadge.jsx";
import { getPermissions } from "../../common/helper/getPermissions.js";

const SettingsLocations = ({ title }) => {
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const { toggle } = useSelector(selectLocationState);
  const { showSpin, hideSpin } = useSpin();
  const [locationsList, setLocationsList] = useState([]);
  const dispatch = useDispatch();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
    const allTeams = useSelector((state) => state.teams.list);

      const main_menu = useSelector((state) => state.menu.items);
      const LocationsPermissions = getPermissions(main_menu, "Settings", "Locations");

  const toggleSwitch = (checked) => {
    dispatch(fetchAllLocations({ token: token, toggle: checked }));
  };
  const state = useSelector(selectLocationState);
  useEffect(() => {
    if (dispatch) {
      dispatch(fetchAllLocations({ token: token, toggle: false }));
    }
  }, [dispatch]);

  useEffect(() => {
    // if (state?.locationList.length > 0) {
      setLocationsList(state?.locationList);
    // }
  }, [state]);

  const handleDeleteClick = (location) => {
    setSelectedLocation(location);
    setDeleteModalVisible(true);
  };

  const handleConfirmDelete = () => {
    if (!selectedLocation) return;
    showSpin();
    DeleteLocation(token, selectedLocation.id)
      .then((res) => {
        if (res?.data?.data?.is_success) {
          message.success(res.data.data.message);
          setLocationsList((prev) =>
            prev.filter((loc) => loc.id !== selectedLocation.id)
          );
        } else {
          message.error(res.data.data.message);
        }
      })
      .catch(() => message.error("Failed to delete location"))
      .finally(() => {
        hideSpin();
        setDeleteModalVisible(false);
        setSelectedLocation(null);
      });
  };

  const handleEdit = (record) => {
    setCurrentLocation(record);
    setDrawerOpen(true);
  };

  const handleAddLocation = () => {
    setCurrentLocation(null);
    setDrawerOpen(true);
  };

  const unauthorize = (error) => {
    if (error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const formatOperatingHours = (receiving_hours) => {
    if (!receiving_hours?.start || !receiving_hours?.end) return "--";

    const start = new Date(receiving_hours.start).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });

    const end = new Date(receiving_hours.end).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${start} - ${end}`;
  };

  const columns = [
    {
      title: "Location name",
      dataIndex: "name",
      key: "name",
       width: 250,
      render: (text) => (
        <div>
        <CustomParagraph
          text={text || "--"}
          fontSize={14}
          fontWeight={600}
          color="#000"
          marginBottom={0}
        />
        </div>
      ),
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
     width: 250,
      render: (text) => (
        <div>
        <CustomParagraph
          text={text || "--"}
          fontSize={14}
          fontWeight={400}
          color="#000"
        />
        </div>
      ),
    },
    {
      title: "Primary contact",
      dataIndex: "contacts",
      key: "contact",
      width: 250,
      render: (contacts) => {
        const primaryContact = contacts?.find((c) => c.is_primary_contact);

        return (
          <div>
            {primaryContact ? (
              <Flex gap={8} align="center">
                <CustomParagraph
                  text={primaryContact.name || "--"}
                  fontSize={12}
                  fontWeight={400}
                  color="#000"
                />
                <div style={{ marginBottom: "0px" }}>
                  <Tooltip title={primaryContact.phone_number || "--"}>
                    <img
                      src={phoneIcon}
                      alt="Phone"
                      style={{
                        width: "12px",
                        height: "12px",
                        marginRight: "5px",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                  <Tooltip title={primaryContact.email || "--"}>
                    <img
                      src={mailIcon}
                      alt="Mail"
                      style={{
                        width: "12px",
                        height: "12px",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </div>
              </Flex>
            ) : (
              <CustomParagraph
                text={"--"}
                fontSize={12}
                fontWeight={400}
                color="#000"
              />
            )}
          </div>
        );
      },
    },
    {
      title: "Operating hours",
      dataIndex: "receiving_hours",
      key: "hours",
      width: 250,
      render: (hours) => (
        <div>
        <CustomParagraph
          text={formatOperatingHours(hours)}
          fontSize={14}
          fontWeight={400}
          color="#000"
        />
        </div>
      ),
    },
    {
      title: "Teams with access",
      dataIndex: "teams",
      key: "teams",
      width: 300,
      render: (_, record) => {
        return (
          <div>
            {record?.teams?.length > 0 ? (
              <div className="flex gap-x-2">
                <TeamBadge
                  color={record?.teams[0]?.color}
                  text={record?.teams[0]?.name}
                  tooltipText={record?.teams[0]?.name}
                />
                {record?.teams.length > 1 && (
                  <Tooltip
                    title={record.teams
                      .slice(1)
                      .map((team) => team.name)
                      .join(", ")}
                    placement="top"
                  >
                    <div
                      style={{
                        display: "inline-block",
                        cursor: "pointer",
                      }}
                    >
                      <TeamBadge
                        color={null}
                        text={`+ ${record?.teams.length - 1}`}
                      />
                    </div>
                  </Tooltip>
                )}
              </div>
            ) : (
              <>
                {" "}
                <div>--</div>{" "}
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
  
          <Flex
            justify="center"
            align="center"
            style={{ width: "42px", gap: "30px", cursor: "pointer" }}
          >
             {record?.permissions?.is_update &&
            <img src={editIcon} alt="Edit" onClick={() => handleEdit(record)} />}
            {record?.permissions?.is_delete &&
            <img
              src={deleteIcon}
              alt="Delete"
              onClick={() => handleDeleteClick(record)}
            />
    }

          </Flex>
      ),
    },
  ];

  const defaultRender = (text) => {
    if (text === null || text === undefined || text === "") {
      return "--";
    }
    return text;
  };


  const TeamsFilteredColumns =
    allTeams?.length > 0
      ? columns
      : columns.filter((column) => column.key !== "teams");

  return (
    <>
      <div className="settings-content-wrapper">
        <Flex align="center" justify="space-between">
          <CustomTitle
            text={`${title} (${locationsList.length})`}
            fontSize={20}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={0}
          />

          <Flex align="center">
            <Tooltip
              title={
                <div
                  style={{
                    textAlign: "center",
                    whiteSpace: "normal",
                    fontSize: "12px",
                    fontWeight: "600",
                    lineHeight: "16px",
                  }}
                >
                  Unknown Locations lack a valid name and need your attention
                </div>
              }
              overlayStyle={{ maxWidth: "154px", textAlign: "center" }}
              placement="top"
            >
              <span>
                <CustomParagraph
                  text={"Show Unknown Locations"}
                  fontSize={12}
                  fontWeight={400}
                  lineHeight="20px"
                  color="#000"
                  marginBottom={0}
                />
              </span>
            </Tooltip>
            <Switch
              checked={toggle}
              onChange={toggleSwitch}
              style={{ marginLeft: "10px" }}
              className="custom-switch"
            />
          </Flex>
        </Flex>

        {/* <Flex vertical={true} gap={32}> */}
        <Table
          columns={TeamsFilteredColumns}
          dataSource={locationsList}
          pagination={false}
          className="settings-table"
        />
        {LocationsPermissions?.is_create &&
        <AddItemButton
          marginTop="0px"
          fontSize="12px"
          fontWeight="600"
          text={"Add location"}
          onClick={handleAddLocation}
        />}
      </div>
      {/* </Flex> */}

      <CustomDeleteModal
        visible={deleteModalVisible}
        onClose={() => setDeleteModalVisible(false)}
        onConfirm={handleConfirmDelete}
        title="Remove Location"
        message="Removing this location will prevent selecting it for future use."
        cancelText="Cancel"
        confirmText="Remove"
        confirmColor="#DE1135"
      />
       {drawerOpen && (
      <CommonDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <LocationForm
          unauthorize={unauthorize}
          locationData={currentLocation}
          drawerOpen={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          refreshLocations={() =>
            dispatch(fetchAllLocations({ token, toggle: false }))
          }
        />
      </CommonDrawer>
       )}
    </>
  );
};

export default SettingsLocations;
